import { isMobile, isTablet } from 'mobile-device-detect'
import { UnitCategoryId } from './enums'

export const isPhone = isMobile && !isTablet

export enum LocalStorageItem {
  email = 'email',
  username = 'username',
  token = 'token',
  cacheEnabled = 'cacheEnabled',
  encryptionEnabled = 'encryptionEnabled',
  registrationPending = 'registrationPending',
  adminTestEmailRecipient = 'adminTestEmailRecipient',
  adminTestSmsRecipient = 'adminTestSmsRecipient',
}

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

export const REGEX_EMAIL_VALIDATION = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
)

export const REGEX_PHONE_VALIDATION = /^\+?[1-9]\d{1,14}$/

export const REGEX_FILTER_NO_SPECIAL_CHARS = /[^\w\s_-]/gi

export const TITLE_FONT_SIZE = 24
export const SUBTITLE_FONT_SIZE = 16
export const LABEL_FONT_SIZE = 16

export const CHART_HEIGHT = 450
export const CHART_DEFAULT_OPTIONS = {
  theme: 'light2',
  animationEnabled: false,
  exportEnabled: true,
  height: CHART_HEIGHT,
  title: {
    text: '',
  },
  axisX: {},
  legend: {
    cursor: 'pointer',
    fontSize: 14,
  },
  toolTip: {
    shared: true,
  },
}

export const DEFAULT_LIMIT = 10000
export const SCHD_INTERVAL_MINUTES = 15

export const DEFAULT_RIC_LOCATION = {
  lat: 34.780792,
  lng: -91.579475,
}

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export type DumpVolumeUnits = 'Cubic Yards' | 'Cubic Meters' | 'Gallons' | 'Liters'

export const DEFAULT_GLOBAL_DUMP_VOLUME = 18
export const DEFAULT_GLOBAL_DUMP_UNITS: DumpVolumeUnits = 'Cubic Yards'

export type DirtTrackerMode = 'Dumps' | 'Cubic Yards'

export const ONE_SECOND = 1000
export const ONE_MINUTE = 60 * ONE_SECOND
export const ONE_HOUR = 60 * ONE_MINUTE
export const ONE_DAY = 24 * ONE_HOUR
export const DAY_IN_SECONDS = 86400
export const DEFAULT_DATE_PERIOD_IN_MS = 28 * DAY_IN_SECONDS * 1000

export enum AlertTypeEnums {
  SYSTEM_CONTROL_MESSAGES = 'SYSTEM_CONTROL_MESSAGES',
  TEST_MESSAGES = 'TEST_MESSAGES',
  SENSOR_ALERTS = 'SENSOR_ALERTS',
  BATTERY_LOW = 'BATTERY_LOW',
  BATTERY_NO_POWER = 'BATTERY_NO_POWER',
  DEVICE_OFFLINE = 'DEVICE_OFFLINE',
  SENSOR_RECOVERY = 'SENSOR_RECOVERY',
  BATTERY_RECOVERY = 'BATTERY_RECOVERY',
  DEVICE_ONLINE_RECOVERY = 'DEVICE_ONLINE_RECOVERY',
}

export const ALERT_SEVERITY_COLORS = {
  critical: '#ef4444',
  warning: '#f59e0b',
  offline: '#f97316',
  recovery: '#22c55e',
} as const

export const ALERT_MARKER_LABELS: Record<string, string> = {
  [AlertTypeEnums.BATTERY_LOW]: 'Low Battery',
  [AlertTypeEnums.BATTERY_NO_POWER]: 'No Power',
  [AlertTypeEnums.BATTERY_RECOVERY]: 'Recovered',
  [AlertTypeEnums.DEVICE_OFFLINE]: 'Offline',
  [AlertTypeEnums.DEVICE_ONLINE_RECOVERY]: 'Recovered',
  [AlertTypeEnums.SENSOR_ALERTS]: 'Sensor Alert',
  [AlertTypeEnums.SENSOR_RECOVERY]: 'Recovered',
}

export const ALERT_MARKER_CAP = 50

export enum ContactTypeEnums {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export interface AlertSettingsItem {
  id?: number
  enabled: boolean
  itemOrder: number
  deviceId: number
  alertType: AlertTypeEnums
  contactType: ContactTypeEnums
  contact: string
  message: string
  totalAttempts: number
  retryDelay: number
  changed: boolean
}

interface UserUnit {
  unitId: number
  precision: number
}

export type UserUnitSettings = Record<string, UserUnit>

interface Conversions {
  metadata: Record<string, any>
  available: Record<number, string>
  abbreviations: Record<number, string>
  formulas: Record<number, string>
}

export type UnitConversions = Record<UnitCategoryId, Conversions>

export const ALERT_SETTINGS_GLOBAL_DEVICE_ID = 0

// Maximum number of devices that can be selected at once in compare mode.
export const MAX_COMPARE_DEVICES = 8

export const MANAGE_DATA_ENABLE_ADVANCED_FEATURES = false
export const MANAGE_DATA_SHOW_ADVANCED_CONTROLS = false
export const MANAGE_DATA_SHOW_ADJUSTMENTS = false
export const MANAGE_DATA_SHOW_TIMESTAMPS = false
export const MANAGE_DATA_SHOW_EXACT_TIMESTAMPS = false
export const MANAGE_DATA_HIDE_DATA_FOR_INDIVIDUAL_SENSORS = false
